import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const activeNotification = createSelector(
    state => state.notifications.activeNotification,
    notification => notification,
);

const loading = createSelector(
    state => state.notifications.loading,
    loading => loading,
);

const getActiveNotification = createAsyncThunk(
    'notifications/getActiveNotification',
    async () => {
        // Use axios to call the public endpoint
        const baseUrl = process.env.NODE_ENV === 'development'
            ? 'http://localhost:5001/fni-blueprint-dev/us-central1'
            : '';

        const response = await axios.get(`${baseUrl}${process.env.NODE_ENV === 'development' ? '/notifications-getActiveNotification_v2' : '/getActiveNotification'}`);
        return response.data;
    },
);

const initialState = {
    activeNotification: null,
    loading: false,
    error: null,
};

export const NotificationsSlice = createSlice({
    name: 'notifications',
    initialState: initialState,
    reducers: {
        clearNotification(state) {
            state.activeNotification = null;
        },
        resetSlice() {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getActiveNotification.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getActiveNotification.fulfilled, (state, action) => {
                state.loading = false;
                state.activeNotification = action.payload.data;
            })
            .addCase(getActiveNotification.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                console.error('Failed to fetch notification:', action.error);
            });
    },
});

export const notificationsActions = {
    ...NotificationsSlice.actions,
    getActiveNotification,
};

export const notificationsSelectors = {
    activeNotification,
    loading,
};

export default NotificationsSlice.reducer;
